import {SectionLabel as KitSectionLabel, cn, type SectionLabelProps} from '@chekinapp/ui';

function SectionLabel({className, ...props}: SectionLabelProps) {
  return <KitSectionLabel className={cn('mx-1 mb-2.5 mt-0.5', className)} {...props} />;
}

export {SectionLabel};
